import { Option } from './../../shared/model/option';
export enum AudioFormatEnum {
  MP3 = 'MP3',
  AAC = 'AAC'
}

export namespace AudioFormatEnum {

  export function getOptions(): Option<AudioFormatEnum>[] {
    return [
      { name: 'Audio MP3', value: AudioFormatEnum.MP3 },
      { name: 'Audio AAC', value: AudioFormatEnum.AAC }
    ];
  }
}